import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const GenericErrorComponent = ({ error }) => {
    return _jsx("h2", { children: error });
};
export default React.memo(GenericErrorComponent);
